export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6289.1b88f6c9.jpg";